<template>
    <v-row no-gutters align="start" class="pt-3">
        <v-col cols="6">
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>Participant: <span class="subheading">{{selectedParticipantName}}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>Result ID: <span class="subheading">{{selectedResultID}}</span>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-col>
        <v-col cols="6">
           <!-- <v-btn depressed
                   @click="showScoringPage"
                   color="primary" class="pa-2" style="float: left; margin-top: 2px">Submit Score</v-btn>-->
            <v-select outlined hide-details dense offset-y
                      class="px-5"
                      label="Map Epoch" :items="basemaps" v-model="selectedBaseMap"></v-select>
        </v-col>
        <router-view/>
    </v-row>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'

  export default {
    name: "Mark",

    computed: {
      ...mapGetters({
        ASSESSMENTS: 'GET_ASSESSMENTS',
        SELECTED_ASSESSMENT: 'GET_SELECTED_ASSESSMENT',
        SEARCH_VALUE: 'GET_MARK_SEARCH_VALUE',
        SELECTED_QUESTION_INFO: 'GET_SELECTED_RESULT_AND_PARTICIPANT'
      }),
      selectedBaseMap: {
        get() {
          return this.$store.getters.GET_SELECTED_BASEMAP;
        },
        set(v) {
          this.$store.commit('SET_BASEMAP', v);
        },
      },
      selectedParticipantName() {
        return this.SELECTED_QUESTION_INFO.participant || "No Participant Selected";
      },
      selectedResultID() {
        return this.SELECTED_QUESTION_INFO.result || "No Result Selected";
      },
    },

    methods: {
      showScoringPage () {
        this.$router.push('/mark/map/scoring')
      },
    },

    data() {
      return {
        basemaps: [
          {text: 'Current Epoch', value: 'https://azmaps.xmap.cloud/epoch18/{z}/{x}/{y}.png'},
          {text: 'Epoch 17', value: 'https://azmaps.xmap.cloud/tiles/{z}/{x}/{y}.png'},
        ],
      }
    }
  }
</script>

<style scoped>

</style>
